import {Action} from '@ngrx/store';

export enum ExplorerViewActionTypes {
  COMMAND_CHANGE_SELECTED_NODE = '[explorer view command: change selected node]'
}

export class ChangeSelectedNode implements Action {
  readonly type = ExplorerViewActionTypes.COMMAND_CHANGE_SELECTED_NODE;
  constructor(public payload: { nodeId: string, type: any, parent: string }) { }
}

export type ExplorerViewActions = ChangeSelectedNode;
